"use client"

import { action_getCountries } from "src/components/actions"
import { createAsyncGlobalState } from "src/hooks/asyncGlobalState"
import { StorefrontCountry } from "src/types/storefront"

export const useCountries = createAsyncGlobalState<StorefrontCountry[]>({
  initialize: () => action_getCountries(),
  initialValue: [],
})
